import axios from 'axios';
import React, { useState } from 'react'
// import QRCode from "react-qr-code";
import Barcode from "react-barcode";
// import { v4 as uuidv4 } from 'uuid';
import Modal from 'react-bootstrap/Modal';
import { usePapaParse } from 'react-papaparse';
import { useCSVDownloader } from 'react-papaparse';
import certificateImage from "../../images/WarrantyCertificate.png"
import DownloadIcon from '@mui/icons-material/Download';

import Spinner from 'react-bootstrap/esm/Spinner';
import html2canvas from 'html2canvas';
import { jsPDF } from "jspdf";


function WarrantyCard({ serverUrl, titleOfPage, user, globalUserId, globalToken }) {
    const { jsonToCSV } = usePapaParse();
    const { CSVDownloader, Type } = useCSVDownloader();

    const [barcodesLoading, setBarcodesLoading] = useState(true)

    const [viewAddWarranty, setViewAddWarranty] = useState(false);

    const [recordsData, setRecordsData] = useState([]);
    const [selectedWarranty, setSelectedWarranty] = useState({});

    const [showWarrantyCertificate, setShowWarrantyCertificate] = useState(false);

    const updateLog = async (data) => {
        const dataSet = {
            "userId": user.userId,
            "changes": data,
        }
        const updateNow = await axios.post(serverUrl + "/users/updateLog", dataSet)
        if (updateNow.status == 200) {
            console.log(updateNow.data)
        } else {
            console.log(updateNow.data)
        }
    }

    const viewWarrantyNow = async (warrantyNumber) => {

        const selectedData = recordsData.filter((record) => { return record.warrantyNumber === warrantyNumber })
        setSelectedWarranty(selectedData[0])
        console.log(selectedData[0])
        setShowWarrantyCertificate(true)
    }
    const getAllBarcodes = async () => {
        const query = { "userId": user.userId }
        const getData = await axios.post(serverUrl + "/warrantyCards/findByUser", query)
        if (getData.status == 200) {
            console.log(getData.data)
            setRecordsData(getData.data)
            setBarcodesLoading(false)
        } else {
            setBarcodesLoading(false)
            console.log(getData.data)
        }
    }

    useState(() => {
        getAllBarcodes()
    }, [])
    return (
        <>
            <div className='h-100 w-100 dataTableSet d-flex flex-column overflow-auto'>
                <div className='w-100 upperMoonsSearchBackground themeTextColor border-0 fs-4 p-0 shadow-sm text-center'>{titleOfPage}</div>
                <div className='p-2 p-md-3 p-lg-3 overflow-auto d-flex flex-column rounded-0 h-100'>
                    <div className='mb-3'>
                        <button className='themeButtons px-4 py-2 rounded-pill fw-bold' onClick={(e) => {
                            setViewAddWarranty(true);
                        }}>new Warranty</button>
                    </div>
                    <div className='overflow-auto'>
                        <table className='table table-light table-bordered w-100 table-striped pb-5 text-center m-0'>
                            <thead className=''>
                                <tr align="center" className='sticky-top'>
                                    <th valign='middle' width="1%"><span className='text-nowrap'>Option</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Barcode Image</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Warranty No.</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Verification No.</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Year of Warranty</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Issue Date</span></th>
                                    <th valign='middle'><span className='text-nowrap'>DD Case Name</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Lab Case No</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Lab Case Description</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Product Name</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Shade Description</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Quantity</span></th>
                                    <th valign='middle'><span className='text-nowrap'>User Id</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Dentist Name</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Dentist Email</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Dentist Address</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Dentist Mobile</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Patient Name</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Patient Email</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Patient Phone</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Patient Address</span></th>
                                    <th valign='middle'><span className='text-nowrap'>Status</span></th>
                                </tr>
                            </thead>
                            {
                                !barcodesLoading ?
                                    <tbody>
                                        {
                                            recordsData.length > 0 ?
                                                recordsData.map((data, key) => {
                                                    return (
                                                        <tr key={key}>
                                                            <td valign='middle'>
                                                                <div className='d-flex gap-2 align-items-center'>
                                                                    <button className='btn btn-sm btn-secondary px-3 py-1 rounded w-100' style={{ minWidth: "50px" }} onClick={(e) => { viewWarrantyNow(data.warrantyNumber) }}>View</button>
                                                                    <button className='themeButtons px-3 py-1 rounded w-100' style={{ minWidth: "50px" }}>Edit</button>
                                                                </div>
                                                            </td>
                                                            <td valign='middle'>
                                                                <Barcode
                                                                    value={data.warrantyNumber}
                                                                    width={2}
                                                                    height={60}
                                                                    format="CODE39"
                                                                    displayValue={true}
                                                                    fontOptions=""
                                                                    font="monospace"
                                                                    // textAlign="center"
                                                                    textPosition="bottom"
                                                                    // textMargin={2}
                                                                    fontSize={35}
                                                                    background="#ffffff"
                                                                    lineColor="#000000"
                                                                    // margin={10}
                                                                    // marginTop=""
                                                                    // marginBottom=""
                                                                    // marginLeft=""
                                                                    // marginRight=""
                                                                    id=""
                                                                    className="barcodeImages"

                                                                />
                                                            </td>
                                                            <td valign='middle'>{data.warrantyNumber}</td>
                                                            <td valign='middle'>{data.verificationCode}</td>
                                                            <td valign='middle'>{data.yearOfWarranty}</td>
                                                            <td valign='middle'>{data.issueDate}</td>
                                                            <td valign='middle'>{data.ddCaseNumber}</td>
                                                            <td valign='middle'>{data.labCaseNumber}</td>
                                                            <td valign='middle'>{data.labCaseDescription}</td>
                                                            <td valign='middle'>{data.productName}</td>
                                                            <td valign='middle'>{data.shadeDescription}</td>
                                                            <td valign='middle'>{data.quantity}</td>
                                                            <td valign='middle'>{data.userId}</td>
                                                            <td valign='middle'>{data.dentistName}</td>
                                                            <td valign='middle'>{data.dentistEmail}</td>
                                                            <td valign='middle'>{data.dentistAddress}</td>
                                                            <td valign='middle'>{data.dentistMobile}</td>
                                                            <td valign='middle'>{data.patientName}</td>
                                                            <td valign='middle'>{data.patientEmail}</td>
                                                            <td valign='middle'>{data.patientMobile}</td>
                                                            <td valign='middle'>{data.patientAddress}</td>
                                                            <td valign='middle'>{data.status}</td>
                                                        </tr>
                                                    )
                                                })
                                                :
                                                <tr>
                                                    <td valign='middle' colSpan={22}>
                                                        <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                            No Data
                                                        </div>
                                                    </td>
                                                </tr>
                                        }
                                    </tbody>
                                    :
                                    <tbody>
                                        <tr>
                                            <td valign='middle' colSpan={22}>
                                                <div className="upperMoonsSearchBackground p-2 themeTextColor fw-bold">
                                                    <Spinner animation="border" variant="dark" size="lg" />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                            }
                        </table>
                    </div>
                </div>
            </div>


            <div className={`warrantyCertificateModal ${showWarrantyCertificate ? "d-flex" : "d-none"} flex-column overflow-auto`} >
                <div className='themeTextColor p-1 fw-bold text-center fs-3 upperMoonsSearchBackground'>
                    Warranty Certificate
                </div>
                <div className='w-100 p-5 bg-light rounded overflow-auto d-flex justify-content-xxl-center'>
                    <div className='border p-5 shadow align-self-start'>
                        <div id='WarrantyCardCertificate' style={{ width: "1420px", height: "1876px", backgroundImage: `url(${certificateImage})`, backgroundSize: "100% 100%", position: "relative" }}>
                            <span className='warrantyDetails warrantyNumberLocation'>{selectedWarranty.codeToSearch}</span>
                            <span className='warrantyDetails verificationNumberLocation'>{selectedWarranty.verificationCode}</span>
                            <span className='warrantyDetails labCaseNumberLocation'>{selectedWarranty.ddCaseNumber}</span>
                            <span className='warrantyDetails yearsOfWarrantyLocation'>{selectedWarranty.yearOfWarranty}</span>

                            <Barcode
                                value={selectedWarranty.warrantyNumber}
                                width={2}
                                height={70}
                                format="CODE39"
                                displayValue={true}
                                fontOptions="bold"
                                font="monospace"
                                // textAlign="center"
                                textPosition="bottom"
                                // textMargin={2}
                                fontSize={40}
                                background="#ffffff"
                                lineColor="#000000"
                                // margin={10}
                                // marginTop=""
                                // marginBottom=""
                                // marginLeft=""
                                // marginRight=""
                                id=""
                                className="warrantyDetails barcodeImageLocation"

                            />
                            <span className='warrantyDetails dateLocation'>{selectedWarranty.issueDate}</span>
                            <span className='warrantyDetails productNameLocation'>{selectedWarranty.productName}</span>
                            <span className='warrantyDetails numberOfUnitLocation'>{selectedWarranty.quantity}</span>
                            <span className='warrantyDetails pointOfSupplyLocation'>{"Super-Admin"}</span>
                            <span className='warrantyDetails caseDescriptionLocation'>{selectedWarranty.labCaseDescription}</span>
                            <span className='warrantyDetails shadeDescriptionLocation'>{selectedWarranty.shadeDescription}</span>
                            <span className='warrantyDetails dentistNameLocation'>{selectedWarranty.dentistName}</span>
                            <span className='warrantyDetails dentistEmailLocation'>{selectedWarranty.dentistEmail}</span>
                            <span className='warrantyDetails dentistNumberLocation'>{selectedWarranty.dentistMobile}</span>
                            <span className='warrantyDetails dentistAddressLocation'>{selectedWarranty.dentistAddress}</span>
                            <span className='warrantyDetails patientNameLocation'>{selectedWarranty.patientName}</span>
                            <span className='warrantyDetails patientEmailLocation'>{selectedWarranty.patientEmail}</span>
                            <span className='warrantyDetails patientNumberLocation'>{selectedWarranty.patientMobile}</span>
                            <span className='warrantyDetails patientAddressLocation'>{selectedWarranty.patientAddress}</span>
                        </div>
                    </div>
                </div>
                <div className='w-100 d-flex justify-content-center gap-2 p-2 upperMoonsSearchBackground'>
                    <input type="button" value="Close" className='btn btn-secondary rounded-pill px-1 py-1 w-100' style={{ maxWidth: "150px" }} onClick={() => { setShowWarrantyCertificate(false) }} />
                    <button type="button" className='themeButtons rounded-pill px-1 py-1 w-100' style={{ maxWidth: "150px" }}
                        onClick={(e) => {

                            html2canvas(document.getElementById('WarrantyCardCertificate'), {
                                allowTaint: true,
                                // useCORS: true,
                                // foreignObjectRendering: true,
                                // logging:true,

                            }).then(function (canvas) {
                                const pdf = new jsPDF({
                                    orientation: "portrait",
                                    unit: "px",
                                    compression: "NONE"
                                });
                                pdf.addImage(canvas.toDataURL("image/jpeg", 1.0), "JPEG", 0, 0, 446, 631);
                                pdf.save("file.pdf");
                            });
                        }}
                    >
                        <DownloadIcon /> Download
                    </button>
                </div>
            </div>

            <Modal
                show={viewAddWarranty}
                onHide={() => { setViewAddWarranty(false) }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>
                        <span className='themeTextColor'>
                            New Warranty
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12 mb-3">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-4 d-flex align-items-center">User Email</div>
                                        <div className="col-8 d-flex align-items-center">
                                            <input type="text" className='customFieldForDence w-100' style={{ maxWidth: "300px" }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className='w-100 d-flex justify-content-center'>
                        <input type="submit" value="Update Now" className='themeButtons rounded-pill px-5 py-2 fw-bold' />
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default WarrantyCard